export default {
  API_ENDPOINT: 'https://warm-shore-32936.herokuapp.com/api'
}
